import { Input } from "antd";

const FormInput = ({label,value,onChange}) => {
    return (<div className="form-input">
        <div className="form-input-title">{label}</div>
        <Input placeholder="" value={value} onChange={onChange} />
    </div>)
};


export default FormInput;